import React from "react";
import { router } from "dva";
import { Menu, Row, Col } from "antd";
import { template, formatDate } from "@reco-m/core";
import { ViewComponent } from "@reco-w/core-ui";
import { Namespaces, headerModel } from "@reco-w/policy-layout-models";
export namespace PageHeader {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, headerModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.header;

        get parkcode() {
            return this.props.match!.params.parkcode;
        }

        componentDidMount() {
            this.dispatch({ type: "input", data: { current: (document.location.pathname as any).split("/")[2] } });

            this.dispatch({ type: "initPage", judgeParkCode: this.parkcode });
        }

        /**
         * 渲染目录栏
         * @returns
         */

        handleClick = (e) => {
            this.dispatch({ type: "input", data: { current: e.key } });
        };

        renderMenu(): React.ReactNode {
            const { state } = this.props,
                current = state!.current;
            return (
                <Menu onClick={this.handleClick} selectedKeys={current} mode="horizontal" className="index-header">
                    <Menu.Item key={"home"}>
                        <router.Link to={"/home"}>首页</router.Link>
                    </Menu.Item>
                    <Menu.Item key={"aliyun"} className="hot">
                        <router.Link to={"/aliyun"}>阿里云特惠</router.Link>
                    </Menu.Item>
                    <Menu.Item key={"park"}>
                        <router.Link to={"/park"}>智慧园区</router.Link>
                    </Menu.Item>
                    <Menu.Item key={"office"}>
                        <router.Link to={"/office"}>智能办公</router.Link>
                    </Menu.Item>
                    <Menu.Item>
                        <router.Link to={"/activity"}>园客栈</router.Link>
                    </Menu.Item>
                    <Menu.Item>
                        <router.Link to={"/activity"}>商务合作</router.Link>
                    </Menu.Item>
                    <Menu.Item>
                        <router.Link to={"/activity"}>关于园小二</router.Link>
                    </Menu.Item>
                </Menu>
            );
        }

        render(): React.ReactNode {
            const arr = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
            const myDate = new Date();
            const cycle = arr[myDate.getDay()];
            const time = formatDate(myDate, "yyyy-MM-dd");
            return (
                <div className="policydeal-header">
                    <div className="container">
                        <Row align="middle">
                            <Col span={16}>
                                <div className="title">
                                    <span>Ipark+政策“一网通办”申报受理服务平台</span>
                                    <em>ipark+zhengceyiwangtongbanshenbaoshoulifuwupingtai</em>
                                </div>
                            </Col>
                            <Col span={8}>
                                <span className="data">
                                    {time} {cycle}
                                </span>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.header]);
}
